module.exports = __webpack_public_path__ + "img/full2-min.7b2df6f9.png";